<template>
  <div>
    <multiselect-ajax
        :key="`${_uid}-drivers`"
        :name="name || 'driver_id'"
        :placeholder="placeholder || $t('Select {something}', { something: $t('drivers.singular') })"
        :value="value"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel"
        :required="required"
        :disabled="disabled"
        :url="`/drivers`"
        :params="{ ...params }"
        :open-direction="openDirection"
        :multiple="multiple"
    >
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect-ajax>
  </div>
</template>

<script>
import MultiselectAjax from "../vue-multiselect-ajax";

export default {
  name: "vehicle-multiselect-ajax",
  components: {
    MultiselectAjax,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: Array,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default(value) {
        return `${value.name} - ${value.phone_number}`
      }
    },
    openDirection: {
      type: String,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    }
  }
}
</script>

<style scoped>

</style>
